<template>
  <div class="songs">
    <h2>Archived Songs</h2>
    <div class="container row">
      <div class="tag-container col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <b-form-group label="Tags">
          <b-form-checkbox
            v-for="(tag, idx) in tags"
            v-model="selectedTags"
            :key="idx"
            :value="tag"
            name="tags"
            v-on:change="filterSongs()"
            size="sm"
          >
            {{ tag }}
          </b-form-checkbox>
        </b-form-group>
        <span class="clear" v-on:click="clearAllTags()"
          ><v-icon class="x-circle" name="x-circle"></v-icon> Clear all</span
        >
      </div>
      <div class="list col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="sort">
          Name - Last Updated
        </div>
        <div class="song" v-for="(song, idx) in songs" :key="idx">
          <div class="link">
            <b-badge v-if="song.unread" class="total-comments" variant="success"
              ><v-icon class="message-square" name="message-square"></v-icon
              >{{ song.comments }}</b-badge
            >
            <b-badge v-else class="total-comments" variant="light"
              ><v-icon class="message-square" name="message-square"></v-icon
              >{{ song.comments }}</b-badge
            >
            <router-link :to="{ path: `/song/${song.key}` }"
              ><span class="title">{{ song.name }}</span> -
              <span class="date">{{ song.date }}</span></router-link
            >
          </div>
          <div class="tags">
            <b-badge
              v-for="(tag, idy) in song.tags"
              :key="idy"
              variant="info"
              >{{ tag }}</b-badge
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.songs {
  .container {
    text-align: left;

    .tag-container {
      margin-bottom: 50px;
    }

    .clear {
      cursor: pointer;

      svg {
        height: 14px;
        width: auto;
        margin: 2px;
      }
    }

    .list {
      .sort {
        font-size: 12px;
      }
      .song {
        margin: 15px 0;
        a {
          color: #2c3e50;
        }
        .total-comments {
          margin-right: 4px;
          svg {
            width: 12px;
            height: auto;
            margin-right: 2px;
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .date {
        font-size: 12px;
      }
    }
  }

  @media only screen and (max-width: 700px) {
    .tag-container {
      display: none;
    }
  }
}
</style>

<script>
import { db, loggedInUser } from "../firebaseConfig";

export default {
  name: "songs",
  data() {
    return {
      songs: [],
      allSongs: [],
      selectedTags: [],
      tags: [],
      name: "",
    };
  },
  async created() {
    const currentUser = await loggedInUser;
    // Get songs
    db.collection("songs")
      .where("active", "==", false)
      .orderBy("lastUpdated", "desc")
      .get()
      .then((querySnapshot) => {
        this.songs = [];
        var tags = [];
        var promises = [];
        querySnapshot.forEach((doc) => {
          // Store tags
          if (doc.data().tags) {
            for (var i = 0; i < doc.data().tags.length; i++) {
              tags[tags.length] = doc.data().tags[i];
            }
          }

          // Sort tags
          this.tags = [...new Set(tags)]; // Remove duplicates
          this.tags.sort();

          // Get comments
          promises[promises.length] = db
            .collection("comments")
            .where("song", "==", doc.id)
            .get()
            .then((commentSnapshot) => {
              var unread = false;
              commentSnapshot.forEach((c) => {
                const comment = c.data();
                if (
                  comment.createdBy.uid !== currentUser.uid &&
                  comment.readBy &&
                  !comment.readBy[currentUser.uid]
                ) {
                  unread = true;
                  return;
                }
              });

              this.allSongs.push({
                key: doc.id,
                name: doc.data().name,
                date: new Date(doc.data().lastUpdated).toLocaleDateString(),
                lastUpdated: doc.data().lastUpdated,
                tags: doc.data().tags,
                comments: commentSnapshot.size,
                unread: unread,
              });
            });
        });

        Promise.all(promises).then(() => {
          // Then filter and display songs
          this.filterSongs();
        });
      });
  },
  methods: {
    deleteSong(id) {
      db.collection("song")
        .doc(id)
        .delete();
    },
    clearAllTags() {
      this.selectedTags = [];
      this.filterSongs();
    },
    filterSongs() {
      setTimeout(() => {
        if (!this.selectedTags.length) {
          this.songs = this.allSongs;
        } else {
          this.songs = [];
          // Loop all songs
          for (var i = 0; i < this.allSongs.length; i++) {
            // Make sure song has tags
            if (this.allSongs[i].tags) {
              // Loop all tags
              for (var j = 0; j < this.allSongs[i].tags.length; j++) {
                if (this.selectedTags.indexOf(this.allSongs[i].tags[j]) > -1) {
                  this.songs[this.songs.length] = this.allSongs[i];
                  break;
                }
              }
            }
          }
        }
        this.songs.sort(function(a, b) {
          return b.lastUpdated - a.lastUpdated;
        });
      }, 50);
    },
  },
};
</script>
